import { useForm } from "react-hook-form";
import { useState, useEffect, useRef } from "react";
import Modal from "./Modal";
import ModalRemove from "./ModalRemove";
import { useDispatch, useSelector } from "react-redux";
import {
  ObtenerTodos,
  Actualizar,
  Eliminar,
  Insertar,
} from "../../redux/tiposOrganizacionesSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import useSubmit from "../../Hooks/useSubmit";
import { OrderTable } from "../../Components/OrderTable";

const columns = [
  { label: "Código", accessor: "tipoOrganizacionId", sortable: true },
  { label: "Nombre", accessor: "tipoOrganizacionNombre", sortable: true },
  { label: "Acción", accessor: "action", sortable: false },
];

function TiposOrganizaciones(props) {
  const [showModal, setShowModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("Agregar");
  const [removeState, changeRemoveState] = useState(false);
  const [itemSelected, setItemSelected] = useState({});
  const { width } = WindowDimension();

  const { submitAction } = useSubmit();

  const dispatch = useDispatch();
  let busqueda = useRef();

  const { tiposOrganizaciones } = useSelector(
    (state) => state.tiposOrganizaciones
  );

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();

  const showModalEdit = (item) => {
    reset(item);
    setTituloModal("Editar");
    setShowModal(true);
  };

  const closeModalEdit = () => {
    reset({ tipoOrganizacionId: 0, tipoOrganizacionNombre: "" });
    setShowModal(false);
  };

  const showRemoveModalEdit = (item) => {
    setItemSelected(item);
    changeRemoveState(true);
  };

  const closeRemoveModalEdit = () => {
    setItemSelected({});
    changeRemoveState(false);
  };

  const cargarOrganizaciones = () => {
    dispatch(ObtenerTodos());
  };

  const cargarOrganizacionesPorCaracter = () => {
    dispatch(ObtenerTodos(busqueda.current.value));
  };

  const eliminar = async () => {
    submitAction(Eliminar, itemSelected.tipoOrganizacionId, () => {
      closeRemoveModalEdit();
      cargarOrganizaciones();
    });
  };

  const onSubmit = async (data) => {
    submitAction(
      data.tipoOrganizacionId > 0 ? Actualizar : Insertar,
      data,
      () => {
        closeModalEdit();
        cargarOrganizaciones();
      }
    );
  };

  useEffect(() => {
    cargarOrganizaciones();
  }, [dispatch]);

  return (
    <div className="main-admin">
      <div className="main-admin-bar">
        <div className="header-admin-bar-items">
          <button
            className="main-admin-button"
            onClick={() => {
              setShowModal(true);
              setTituloModal("Agregar");
              setValue("tipoOrganizacionNombre", "");
              reset();
            }}
          >
            +
          </button>
          <h2>Tipos de organizaciones</h2>
        </div>

        <div className="header-admin-bar-items ml-auto">
          <label hidden>Búsqueda</label>
          <input
            type="search"
            className="form-control"
            onInput={cargarOrganizacionesPorCaracter}
            placeholder="Búsqueda"
            ref={busqueda}
          />
        </div>
      </div>

      <div className="table-container">
        {tiposOrganizaciones.length > 0 ? (
          <OrderTable
            {...{ columns }}
            data={tiposOrganizaciones}
            clase="table-adm"
            actions={[
              {
                icon: "",
                clase: "text-primary",
                style: { display: "contents" },
                event: (item) => showModalEdit(item),
              },
              {
                icon: "",
                clase: "delete",
                style: { display: "contents" },
                event: (item) => showRemoveModalEdit(item),
              },
            ]}
          />
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>

      <Modal
        estado={showModal}
        cambiarEstado={closeModalEdit}
        titulo={tituloModal}
        clase={`${width < 576 ? "full-width" : "small"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(onSubmit)}
            >
              Guardar
            </button>
          </>
        }
      >
        <form>
          <div className="form-group">
            <i className="material-icons important"></i>
            <label>Tipo de organización</label>
            <input
              className="form-control"
              name="tipoOrganizacionNombre"
              {...register("tipoOrganizacionNombre", {
                required: "Campo requerido",
              })}
            />
            {errors.tipoOrganizacionNombre && (
              <p className="error">{errors.tipoOrganizacionNombre.message}</p>
            )}
          </div>
        </form>
      </Modal>

      <ModalRemove
        estado={removeState}
        closeModalHandled={closeRemoveModalEdit}
        title="Eliminar plantillla"
        message="¿Seguro que desea eliminar el siguiente registro?"
        item={itemSelected.tipoOrganizacionNombre}
        btnGroup={
          <>
            <button className="button-text text-red" onClick={eliminar}>
              Confirmar
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                closeRemoveModalEdit(false);
              }}
            >
              Cancelar
            </button>
          </>
        }
      />
    </div>
  );
}

export default TiposOrganizaciones;
